import mixins from 'vue-typed-mixins';

import { E勘定科目カテゴリ, E製造原価科目未使用フラグ } from '@/openapi/enum';

import 事業所Mixin from '@/entries/user/mixins/事業所Mixin';
import 勘定科目ListEditMixin from '@/components/勘定科目/listEdit/勘定科目ListEditMixin';

export default mixins(事業所Mixin, 勘定科目ListEditMixin).extend({
  name: 'C勘定科目ListEditNewButton',

  props: {
    is貸借: {
      type: Boolean,
      required: true,
    },
  },

  data(): {
    enum勘定科目カテゴリ: typeof E勘定科目カテゴリ;
  } {
    return {
      enum勘定科目カテゴリ: E勘定科目カテゴリ,
    };
  },

  computed: {
    buttons(): {
      label: string;
      value: E勘定科目カテゴリ;
    }[] {
      if (this.is貸借)
        return [
          {
            label: '勘定科目追加',
            value: E勘定科目カテゴリ.貸借,
          },
        ];

      const buttons = [
        {
          label: '損益科目追加',
          value: E勘定科目カテゴリ.損益,
        },
      ];
      if (this.事業所.c製造原価科目未使用フラグ === E製造原価科目未使用フラグ.使用する)
        buttons.push({
          label: '製造原価科目追加',
          value: E勘定科目カテゴリ.製造原価,
        });
      return buttons;
    },
  },
});
